import { render } from "./Sindh.vue?vue&type=template&id=f6d61abc&scoped=true"
const script = {}

import "./Sindh.vue?vue&type=style&index=0&id=f6d61abc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d61abc"]])

export default __exports__